import { render, staticRenderFns } from "./DigitalSignature.vue?vue&type=template&id=c88b7c76&scoped=true&"
import script from "./DigitalSignature.vue?vue&type=script&lang=js&"
export * from "./DigitalSignature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c88b7c76",
  null
  
)

export default component.exports